import { styled, css } from 'styled-components';
import { Link } from '@/js/libs/router';
export const ClickableDropdownItemWrapper = styled.div `
  padding: 10px 16px;
  position: relative;
  ${({ theme }) => theme.typography.textMedium};
  min-height: 36px;
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 8px;
  transition: 0.15s;
  white-space: ${({ wrap }) => (wrap ? 'normal' : 'nowrap')};
  color: ${({ theme }) => theme.colors.black_1};

  ${({ disabled }) => disabled &&
    css `
      opacity: 0.3;
      cursor: not-allowed;
    `}
  ${({ theme, disabled, $isSelected }) => !disabled &&
    css `
      cursor: pointer;
      ${$isSelected &&
        css `
        background-color: ${theme.colors.grey05_1};
      `}

      &:hover {
        background-color: ${theme.colors.grey05_1};
        color: ${theme.colors.blackDark_1};
      }
    `}
  ${({ theme, $last }) => $last &&
    css `
      border-top: 1px solid ${theme.colors.grey10_1};
    `}
`;
export const LinkDropdownItemWrapper = styled(ClickableDropdownItemWrapper).attrs({ as: Link }) `
  &&& {
    color: ${({ theme }) => theme.colors.black_1};
  }
`;
